import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ListaPropostasPJ from '../ListaPropostasPJ';



class ListaPropostasPJPendentes extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render() {

    return (
      <ListaPropostasPJ history={this.props.history}/>
    );

  }

}

ListaPropostasPJPendentes.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostasPJPendentes);